module.exports = "/../../dist/frontend/images/vehicule_electrique.webp?ed067b80ce65db4b31082b8d91485f91";